import { ImageAnonymizationType } from '@dermloop/static-values';
import {
  IsBoolean,
  IsEnum,
  IsNumber,
  IsOptional,
  IsUUID,
  Max,
  Min,
} from 'class-validator';

/**
 * DTO representing a detailed training condition anonymization.
 */
export interface TrainingConditionAnonymizationDto {
  anonymizationId: string;

  anonymizationSkipped: boolean;

  anonymizationApproved: boolean;

  trainingConditionId: string;

  trainingConditionStatusId: string;

  trainingConditionDiagnosisId?: string;

  trainingConditionSecondaryDiagnosisId?: string;

  trainingConditionClinicalImageId: string;

  focalPointX: number;

  focalPointY: number;

  trainingConditionClinicalImageUrl: string;

  trainingConditionUdfImageUrl: string;

  trainingConditionUdfNsImageUrl: string;
}

/**
 * DTO representing a search result for a training condition anonymization.
 * It is intended for list views of training condition anonymizations.
 */
export interface TrainingConditionAnonymizationSearchResultDto {
  anonymizationId: string;

  anonymizationSkipped: boolean;

  trainingConditionClinicalImageId: string;

  trainingConditionId: string;

  trainingConditionStatusId: string;

  trainingConditionDiagnosisId?: string;

  trainingConditionSecondaryDiagnosisId?: string;
}

/**
 * DTO for searching training condition anonymizations.
 */
export class TrainingConditionAnonymizationSearchDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(200)
  skip?: number;

  @IsNumber()
  @Min(1)
  @Max(200)
  take: number;

  @IsOptional()
  @IsUUID('all', { each: true })
  trainingConditionStatusIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  trainingConditionDiagnosisIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  trainingConditionSecondaryDiagnosisIds?: string[];

  @IsOptional()
  @IsBoolean()
  anonymizationSkipped?: boolean;
}

export class ApproveTrainingConditionAnonymizationDto {
  @IsNumber()
  @Min(0)
  @Max(1)
  focalPointX: number;

  @IsNumber()
  @Min(0)
  @Max(1)
  focalPointY: number;

  @IsEnum(ImageAnonymizationType)
  approvedAnonymizationImageType: ImageAnonymizationType;
}
